import { IModalManagerCProps, IModalManagerProps } from '../entities';

const BCModalManager = (props: IModalManagerProps & IModalManagerCProps) => {
	const modals = props.items.map(item => {
		const ComponentType = props.components ? props.components[item.type] : null;
		return (
			<ComponentType
				key={item.id}
				{...item.props}
				id={item.id}
				visible={item.visible}
				width={item.width}
			/>
		);
	});

	return <>{modals}</>;
};

export default BCModalManager;
